export default __webpack_public_path__ + "static/media/77_header_requisition.e6f368db.png";